export default "__VITE_ASSET__D4hvO54R__"